<app-nav titulo="Servicios" descripcion="Aquí podrá ver, editar y borrar todos los servicios disponibles para vender al propietario junto con el alquiler.">
    <div class="services">
        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="services"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateServices($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
        <button mat-raised-button class="garantor-button add-button" color="primary" routerLink="./nuevo">
            <mat-icon matPrefix class="add-button-icon">add</mat-icon>
            <span class="add-button-label">Nuevo servicio</span>
        </button>
    </div>
</app-nav>
<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Ver detalles" class="view-more-row-button" [routerLink]="'./' + row.id">
            <mat-icon color="primary">dehaze</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Editar servicio" class="edit-row-button" [routerLink]="'./' + row.id + '/editar'">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Borrar servicio" class="delete-row-button" (click)="deleteService(row)">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
